import JackpotWinnerModal from '@/components/molecules/JackpotWinnerModal/JackpotWinnerModal'
import GameStats from '@/components/molecules/JackpotGameModal/JackpotGameModal'
import BlockStats from '@/components/molecules/BlockStatsModal/BlockStatsModal'
import MinesGameDetails from '@/components/molecules/MinesGameModal/MinesGameModal'
import DoubleGameDetails from '@/components/molecules/DoubleGameDetails/DoubleGameDetails'
import GameRules from '@/components/molecules/RulesModal/RulesModal'
import DoubleJackpot from '@/components/molecules/DoubleJackpot/DoubleJackpot'
import React, { Attributes, FunctionComponent, lazy, Suspense, useEffect } from 'react'
import { CountryRestrictedModal } from '@/components/organisms/CountryRestrictedModal'
import { ShareResultModal } from '@/components/molecules/ShareResultModal/ShareResultModal'
import { useRouter } from 'next/router'
import { AirdropChecker } from '@/components/molecules/AirdropChecker/AirdropChecker'
import { LoadingModal } from '@/components/molecules/LoadingModal/LoadingModal'
import { MaintenanceModal } from '@/components/molecules/MaintenanceModal/MaintenanceModal'
import { PromoCodeModal } from '@/components/molecules/PromoCode/PromoCode'
import { create } from 'zustand'
import { MinesContestModal } from '@/components/molecules/MinesContestModal/MinesContestModal'
import UserStatsModal from '@/components/molecules/UserStatsModal/UserStatsModal'
import { CoinflipGameDetails } from '@/components/molecules/CoinflipGameDetails/CoinflipGameDetails'
import { CoinflipContestModal } from '@/components/molecules/CoinflipContestModal/CoinflipContestModal'
import { VerifyAutofillModal } from '@/components/templates/Verify/organisms/VerifyAutofillModal'
import { SendTipModal } from '@/components/molecules/SendTipModal/SendTipModal'
import { RunesGameDetails } from '@/components/molecules/RunesGameDetails/RunesGameDetails'
import PlinkoGameDetails from '@/components/molecules/PlinkoGameModal/PlinkoGameModal'
import GameZoneGameDetails from '@/components/molecules/GameZoneGameModal/GameZoneGameModal'
import { ShuFaucetModal } from '@/components/molecules/ShuFaucetModal/ShuFaucetModal'
import { UsdcConversionModal } from '@/components/molecules/UsdcConversionModal/UsdcConversionModal'
import { CashierModal } from '@/components/molecules/CashierModal/CashierModal'
import { GameZoneWithdrawModal } from '@/components/molecules/GameZoneWithdrawModal/GameZoneWithdrawModal'

export const AppModals = {
  Account: {
    name: 'Account',
    component: lazy(() => import('@/components/organisms/AccountModal/AccountModal')),
  },
  UsdcConversion: {
    name: 'UsdcConversion',
    component: UsdcConversionModal,
  },
  Cashier: {
    name: 'Cashier',
    component: CashierModal,
  },
  GameZoneWithdraw: {
    name: 'GameZoneWithdraw',
    component: GameZoneWithdrawModal,
  },
  UserStats: {
    name: 'UserStats',
    component: UserStatsModal,
    // component: lazy(() => import('@/components/molecules/UserStatsModal/UserStatsModal')),
  },
  GameStats: {
    name: 'GameStats',
    component: GameStats,
  },
  GameRules: {
    name: 'GameRules',
    component: GameRules,
  },
  MinesContestModal: {
    name: 'MinesContestModal',
    component: MinesContestModal,
  },
  CoinflipContestModal: {
    name: 'CoinflipContestModal',
    component: CoinflipContestModal,
  },
  MinesGameDetails: {
    name: 'MinesGameDetails',
    component: MinesGameDetails,
  },
  DoubleGameDetails: {
    name: 'DoubleGameDetails',
    component: DoubleGameDetails,
  },
  CoinflipGameDetails: {
    name: 'CoinflipGameDetails',
    component: CoinflipGameDetails,
  },
  RunesGameDetails: {
    name: 'RunesGameDetails',
    component: RunesGameDetails,
  },
  PlinkoGameDetails: {
    name: 'PlinkoGameDetails',
    component: PlinkoGameDetails,
  },
  GameZoneGameDetails: {
    name: 'GameZoneGameDetails',
    component: GameZoneGameDetails,
  },
  DoubleJackpot: {
    name: 'DoubleJackpot',
    component: DoubleJackpot,
  },
  OauthAccountConnectModal: {
    name: 'OauthAccountConnectModal',
    component: lazy(() => import('@/components/molecules/OauthAccountConnectModal/OauthAccountConnectModal')),
  },
  AdminPanel: {
    name: 'AdminPanel',
    component: lazy(() => import('@/components/molecules/AdminPanelModal/AdminPanelModal')),
  },
  CountryRestrictedModal: {
    name: 'CountryRestrictedModal',
    component: CountryRestrictedModal,
  },
  ShareResultModal: {
    name: 'ShareResultModal',
    component: ShareResultModal,
  },
  AirdropChecker: {
    name: 'AirdropChecker',
    component: AirdropChecker,
  },
  DepositModal2: {
    name: 'DepositModal2',
    component: lazy(() => import('@/components/molecules/DepositModal/DepositModal')),
  },
  InsufficientNeedCoverFromGameAccount: {
    name: 'InsufficientNeedCoverFromGameAccount',
    component: lazy(
      () => import('@/components/molecules/InsufficientNeedCoverFromGameAccount/InsufficientNeedCoverFromGameAccount')
    ),
  },
  LoadingModal: {
    name: 'LoadingModal',
    component: LoadingModal,
  },
  MaintenanceModal: {
    name: 'MaintenanceModal',
    component: MaintenanceModal,
  },
  PromoCodeModal: {
    name: 'PromoCodeModal',
    component: PromoCodeModal,
  },
  ExportPrivateKeyModal: {
    name: 'ExportPrivateKeyModal',
    component: lazy(() => import('@/components/molecules/ExportPrivateKeyModal/ExportPrivateKeyModal')),
  },
  ExportThirdWebPrivateKeyModal: {
    name: 'ExportThirdWebPrivateKeyModal',
    component: lazy(() => import('@/components/molecules/ExportPrivateKeyModal/ExportThirdWebPrivateKeyModal')),
  },
  VerifyAutofill: {
    name: 'VerifyAutofill',
    component: VerifyAutofillModal,
  },
  SendTip: {
    name: 'SendTip',
    component: SendTipModal,
  },
  ShuFaucet: {
    name: 'ShuFaucet',
    component: ShuFaucetModal,
  },
}

export const JackpotModals = {
  JackpotWinnerModal: {
    name: 'JackpotWinnerModal',
    component: JackpotWinnerModal,
  },
  BlockStats: {
    name: 'BlockStats',
    component: BlockStats,
  },
}

type Modal = { id: string; component: any; props: any; element: any }

type ModalStore = {
  modals: Array<Modal>
  openModalNew: <P extends {}>(
    modal: { component: FunctionComponent<P> },
    props?: (Attributes & Omit<P, 'onClose'>) | null
  ) => { id: string; modal: React.Ref<any> }
  closeModalById: (id: string) => void
  closeAllModals: () => void
}

const useModalStore = create<ModalStore>((set, get) => ({
  modals: [] as Array<Modal>,

  openModalNew: <P extends {}>(
    modal: { component: FunctionComponent<P> },
    props?: (Attributes & Omit<P, 'onClose'>) | null
  ) => {
    const id = Date.now().toString()
    const element = React.createElement(modal.component, {
      key: id,
      onClose: () => get().closeModalById(id),
      ...props,
    } as any) as any

    set((state) => {
      return { modals: [...state.modals, { id, props: props, element } as any] }
    })

    return {
      id,
      modal: element,
    }
  },
  closeModalById(id: string) {
    set((state) => {
      return { modals: [...state.modals.filter((x) => x.id !== id)] }
    })
  },
  closeAllModals() {
    set(() => {
      return { modals: [] }
    })
  },
}))

export const ModalProvider: React.FC<React.PropsWithChildren> = ({}) => {
  const { events } = useRouter()

  const { modals, closeAllModals } = useModalStore()

  useEffect(() => {
    events.on('routeChangeStart', closeAllModals)
    return () => {
      events.off('routeChangeStart', closeAllModals)
    }
  }, [events])

  return <Suspense>{...modals.map((x) => x.element)}</Suspense>
}

export const useAppModal = useModalStore
